import classnames from 'classnames'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import ReactSVG from 'react-svg'

import AbilitiesMapIcon from 'assets/img/abilities_map_icon.svg'
import ActivitiesIcon from 'assets/img/activities_icon.svg'
import GamesIcon from 'assets/img/games_icon.svg'
import QuestionnairesIcon from 'assets/img/questionnaires_icon.svg'

import {
  ActivitiesModal,
  GameInstallationModal,
  NewScoreModal,
  ProgressionEvaluationModal,
  TempEvalStatusModal
} from 'components'
import { databaseRef } from 'config/firebase'
import { bindActionCreators } from 'redux'
import { _route } from 'routes/config'
import { getGamesCount } from 'services/games'
import { getQuestionnairesCount } from 'services/questionnaires'
import SnackbarService from 'services/snackbars'

import EvaluationWarningModal from 'components/EvaluationWarningModal'
import { isMobile } from 'react-device-detect'
import { getDeviceLink } from 'services/downloadApp'
import { getAge } from 'services/utils'
import * as PatientActions from 'store/patients/actions'
import './style.scss'

interface INativeProps {
  openPlusOnlyPopup: () => void
  isEvaluationCompletedOpen?: boolean
}
interface IReduxStateProps {
  patientDetail: any
  forms: any
  user: any
  plusUser: any
}

interface IReduxDispatchProps {
  PatientsLib: any
}
interface IReduxProps extends IReduxStateProps, IReduxDispatchProps {}

interface ITab {
  img: any
  notificationsCount: number | null
  path: string
  id: string
  tooltipTitle: string
  plusUserOnly?: boolean
  include: boolean
}

interface IProps
  extends INativeProps,
    IReduxProps,
    RouteComponentProps<{ id: string }> {}

interface IState {
  parents: any[]
  loading: boolean
  progressionEvaluationModalOpen: boolean
  gameInstallationModalOpen: boolean
  gamesCount: number
  questionnairesCount: number
  assessmentCompleted: boolean
  isTempEvalStatusModalOpen: boolean
  newScoreModalOpen: boolean
  evaluationWarningModalOpen: boolean
  isActivitiesOpen: boolean
  gamesCompleted: boolean
  isEvaluationCompletedOpen: boolean
}

class PatientDetail extends React.PureComponent<IProps, IState> {
  state = {
    parents: [],
    loading: false,
    progressionEvaluationModalOpen: false,
    gameInstallationModalOpen: false,
    gamesCount: 0,
    questionnairesCount: 0,
    assessmentCompleted: false,
    isTempEvalStatusModalOpen: false,
    newScoreModalOpen: false,
    evaluationWarningModalOpen: false,
    isActivitiesOpen: false,
    gamesCompleted: false,
    isEvaluationCompletedOpen: false
  }

  componentDidMount() {
    this.updState()
  }

  componentDidUpdate(prevProps) {
    const assessment = this.props.patientDetail.assessments
    const isAbilityFinished =
      assessment &&
      assessment.hasOwnProperty('have_new_score') &&
      assessment.have_new_score === 0
    const QuestionairesFinished =
      assessment && assessment.have_new_score && assessment.have_new_score === 1
    const GamesFinished =
      assessment && assessment.have_new_score && assessment.have_new_score === 2
    const EvaluationCompleted =
      assessment && assessment.have_new_score && assessment.have_new_score === 3
    const { assessmentCompleted } = this.state

    if (isAbilityFinished) {
      this.checkIfToRenderNewScore(assessmentCompleted)
    }

    if (QuestionairesFinished) {
      this.checkIfToRenderQuestionarieFinished()
    }

    if (GamesFinished) {
      this.checkIfToRenderGamesFinished()
    }

    if (EvaluationCompleted) {
      this.removeHaveNewScoreFromRef().then(() => {
        this.setState({ isEvaluationCompletedOpen: true })
      })
      return
    }

    const { patientDetail } = this.props
    const { patientDetail: prevPatientDetail } = prevProps

    if (patientDetail && patientDetail !== prevPatientDetail) {
      this.updState()
    }
  }

  checkIfToRenderQuestionarieFinished() {
    this.setState({
      progressionEvaluationModalOpen: true
    })
    this.removeHaveNewScoreFromRef()
  }

  checkIfToRenderGamesFinished() {
    this.setState({
      progressionEvaluationModalOpen: true,
      gamesCompleted: true
    })
    this.removeHaveNewScoreFromRef()
  }

  checkIfToRenderNewScore(assessmentCompleted) {
    this.setState({ newScoreModalOpen: true })
    this.removeHaveNewScoreFromRef()
  }

  updState = () => {
    const { patientDetail, isEvaluationCompletedOpen } = this.props
    const gamesCount = getGamesCount(patientDetail)
    const questionnairesCount = getQuestionnairesCount(patientDetail)
    const currentAssessmentTimestamp: string | number =
      patientDetail.currentAssessment
    const haveDateLocked = !!patientDetail.assessments[
      currentAssessmentTimestamp
    ]?.date_locked

    this.setState({
      gamesCount,
      questionnairesCount,
      assessmentCompleted:
        (gamesCount === 0 && questionnairesCount === 0) || haveDateLocked
    })
    if (isEvaluationCompletedOpen) {
      this.setState({ isEvaluationCompletedOpen })
    }
  }

  getTabs = (): ITab[] => {
    const { patientDetail, user } = this.props
    const { gamesCount, questionnairesCount, assessmentCompleted } = this.state
    const havePhoneNumber = user && user?.phone_number ? true : false
    const activitiesNotificationsCount =
      assessmentCompleted && !havePhoneNumber ? 1 : null

    return [
      {
        path: _route.abilities(patientDetail.patientId),
        notificationsCount: null,
        img: AbilitiesMapIcon,
        id: 'abilities-tour-step',
        tooltipTitle: 'Abilities',
        include: true
      },
      {
        path: 'coming soon',
        notificationsCount: activitiesNotificationsCount,
        img: ActivitiesIcon,
        id: 'activities-tour-step',
        tooltipTitle: 'Activities',
        plusUserOnly: true,
        include: false
      },
      {
        path: _route.questionnaires(patientDetail.patientId),
        notificationsCount: questionnairesCount,
        img: QuestionnairesIcon,
        id: 'questionnaires-tour-step',
        tooltipTitle: 'Questionnaires',
        include: true
      },
      {
        path: _route.games(patientDetail.patientId),
        notificationsCount: gamesCount,
        img: GamesIcon,
        id: 'evaluation-games-tour-step',
        tooltipTitle: 'Games',
        include: true
      }
    ]
  }

  pushToGamesPage = (userCameFromQuestionnaires: boolean) => {
    const { patientDetail, history } = this.props
    history.push(_route.games(patientDetail.patientId), {
      userCameFromQuestionnaires
    })
  }

  renderTempEvalStatusModal() {
    const { patientDetail, history } = this.props
    const {
      isTempEvalStatusModalOpen,
      questionnairesCount,
      gamesCount
    } = this.state
    const currentPath = location.pathname
    const tabs = this.getTabs()
    const questionnairesTab = tabs[2]

    return (
      isTempEvalStatusModalOpen && (
        <TempEvalStatusModal
          open={isTempEvalStatusModalOpen}
          onSubmit={() => {
            this.setState({ isTempEvalStatusModalOpen: false }, () => {
              history.push(
                _route.games(
                  patientDetail?.patientId,
                  questionnairesCount > 0 ? 1 : 2
                )
              )
            })
          }}
          onClose={() => this.setState({ isTempEvalStatusModalOpen: false })}
          questionnairesCount={questionnairesCount}
          gamesCount={gamesCount}
          goToQuestionnaires={() => {
            this.props.PatientsLib.UpdateQuestionnarie(true, () =>
              history.replace(_route.questionnaires(patientDetail.patientId))
            )
          }}
          goToGames={() => {
            const {
              history: { location }
            } = this.props

            location.state = {
              ...(location.state as object),
              fromModal: true
            }

            this.pushToGamesPage(currentPath === questionnairesTab.path)
          }}
        />
      )
    )
  }

  renderProggressionEvaluationModal() {
    const tabs = this.getTabs()
    const questionnairesTab = tabs[2]
    const gamesTab = tabs[3]

    const { history, location, patientDetail, user } = this.props

    const {
      questionnairesCount,
      gamesCount,
      assessmentCompleted,
      progressionEvaluationModalOpen,
      gamesCompleted
    } = this.state

    const currentPath = location.pathname

    const showGames =
      assessmentCompleted ||
      questionnairesCount === 0 ||
      currentPath === gamesTab.path

    const showQuestionnaries =
      assessmentCompleted ||
      gamesCount === 0 ||
      currentPath === questionnairesTab.path

    const pushToGamesPage = () => {
      history.push(_route.games(patientDetail.patientId), {
        userCameFromQuestionnaires: true
      })
    }
    const getGamesApp = () => {
      if (isMobile && user.logged_in_game) {
        window.open(getDeviceLink())
      } else {
        this.setState({
          progressionEvaluationModalOpen: false,
          gameInstallationModalOpen: true
        })
      }
    }

    return (
      progressionEvaluationModalOpen && (
        <ProgressionEvaluationModal
          age={getAge(patientDetail.birth_date)}
          open={progressionEvaluationModalOpen}
          questionnairesCount={questionnairesCount}
          gamesCount={gamesCount}
          showGames={gamesCompleted ? true : showGames}
          showQuestionnaries={gamesCompleted ? true : showQuestionnaries}
          onClose={() => {
            this.setState({
              progressionEvaluationModalOpen: false,
              gamesCompleted: false
            })
          }}
          onSubmit={() => {
            if (showQuestionnaries && questionnairesCount !== 0) {
              this.props.PatientsLib.UpdateQuestionnarie(true, () =>
                history.replace('/questionnaires', true)
              )
            } else if (showGames && gamesCount !== 0) {
              history.location.state = {
                ...(history.location.state as object),
                fromModal: true
              }
              currentPath === questionnairesTab.path
                ? pushToGamesPage()
                : getGamesApp()
              // uniweb
              // window.location.href = `uniwebview://action?cid=${patientDetail.patientId}&cname=${patientDetail.first_name}`
            } else {
              this.setState({ progressionEvaluationModalOpen: false })
              // window.history.back()
              history.push(_route.abilities(patientDetail.patientId))
            }
          }}
          history={history}
          relevantAssessment={patientDetail.assessments.relevant_assessment}
        />
      )
    )
  }

  renderGameInstallationModal() {
    const { user } = this.props
    const { gameInstallationModalOpen } = this.state

    return (
      <GameInstallationModal
        open={gameInstallationModalOpen}
        onClose={() => this.setState({ gameInstallationModalOpen: false })}
        user={user}
      />
    )
  }

  renderTabs = () => {
    const tabs = this.getTabs()
    const {
      history,
      match,
      location,
      patientDetail,
      plusUser,
      openPlusOnlyPopup
    } = this.props
    const currentPath = location.pathname
    const { assessmentCompleted, gamesCount, questionnairesCount } = this.state
    const isPlusUser = plusUser
    const goToPlus = () => {
      history.push(_route.payment, { canGoBack: true })
    }

    return (
      <div className="tabs">
        {tabs
          .filter(tab => tab.include)
          .map(
            (
              { path, notificationsCount, img, id, tooltipTitle, plusUserOnly },
              i
            ) => (
              <div
                id={id}
                key={id}
                className={classnames('tab image-tab tooltip-wrap', {
                  active: currentPath === path,
                  completed:
                    (path === _route.games(patientDetail?.patientId) &&
                      gamesCount === 0) ||
                    (path === _route.questionnaires(patientDetail?.patientId) &&
                      questionnairesCount === 0) ||
                    (path === _route.abilities(patientDetail?.patientId) &&
                      assessmentCompleted),
                  clickable: true
                })}
                onClick={() => {
                  if (plusUserOnly && !plusUser) {
                    if (openPlusOnlyPopup) {
                      openPlusOnlyPopup()
                    }
                  } else {
                    if (path === 'coming soon') {
                      if (isPlusUser) {
                        if (assessmentCompleted) {
                          isPlusUser
                            ? this.setState({ isActivitiesOpen: true })
                            : history.push(_route.payment, { canGoBack: true })
                        } else {
                          SnackbarService.showSnackbar(
                            "Unlock the 'Activities' tab by completing all the games and questionnaires",
                            'info'
                          )
                        }
                      } else {
                        goToPlus()
                      }

                      return
                    }
                    // temporary solution
                    if (path === _route.abilities(match.params.id)) {
                      if (path !== currentPath) {
                        history.push(path)
                      } else {
                        // if (isPlusUser) {
                        return (
                          !assessmentCompleted &&
                          this.setState({ isTempEvalStatusModalOpen: true })
                        )
                        // }
                        // * before returning this check clickable class
                        // else {
                        //   goToPlus()
                        // }
                      }

                      return
                    }

                    if (path !== currentPath) {
                      history.push(path)
                    } else {
                      if (
                        patientDetail.currentAssessment !==
                        patientDetail.assessments.relevant_assessment
                      ) {
                        this.setEvaluationWarningModalOpen(true)
                      } else if (
                        !assessmentCompleted ||
                        (assessmentCompleted && plusUser)
                      ) {
                        this.setState({ progressionEvaluationModalOpen: true })
                      } else if (!plusUser) {
                        goToPlus()
                      }
                    }
                  }
                }}
              >
                <div className="image-wrap">
                  <ReactSVG className="forms-avatar image" src={img} />
                  {(notificationsCount ?? 0) > 0 && (
                    <div className="notification-indicator">
                      {notificationsCount}
                    </div>
                  )}
                  {plusUserOnly && !plusUser && (
                    <ReactSVG
                      className="locked-indicator"
                      src={require('../../assets/img/crown.svg')}
                    />
                  )}
                </div>{' '}
                <span className="tooltip__item tooltip__item--nowrap">
                  {tooltipTitle}
                </span>
              </div>
            )
          )}
      </div>
    )
  }

  removeHaveNewScoreFromRef = async () => {
    const id = this.props.patientDetail.patientId
    try {
      const childRef = await databaseRef
        .child('children')
        .child(id)
        .child('assessments')
        .child('have_new_score')
      childRef.remove()
    } catch (err) {
      console.error({ err })
    }
  }

  renderNewScoreModal = () => {
    const { history, patientDetail, plusUser } = this.props
    const { newScoreModalOpen, isEvaluationCompletedOpen } = this.state
    const currentPatientId = patientDetail.patientId
    const isPlusUser = plusUser
    const goToPlus = () => {
      history.push(_route.payment, { canGoBack: true })
    }
    const isOpen = newScoreModalOpen || isEvaluationCompletedOpen
    return (
      isOpen && (
        <NewScoreModal
          open={isOpen}
          onClose={() => {
            this.setState({
              newScoreModalOpen: false,
              isEvaluationCompletedOpen: false
            })
            // window.history.back()
          }}
          onSubmit={() => {
            this.setState({
              newScoreModalOpen: false,
              isEvaluationCompletedOpen: false
            })
            history.replace(_route.abilities(currentPatientId))
          }}
          isPlusUser={isPlusUser}
          goToPlus={goToPlus}
          isEvaluationCompletedOpen={isEvaluationCompletedOpen}
        />
      )
    )
  }

  renderActivitiesModal = () => {
    const activitiesModalOpen = this.state.isActivitiesOpen
    const currentPatient = this.props.patientDetail
    const havePhoneNumber = this.props?.user?.phone_number
    const history = this.props.history

    return (
      <ActivitiesModal
        open={activitiesModalOpen}
        onClose={() => {
          this.setState({ isActivitiesOpen: false })
        }}
        onSubmit={() => {
          this.setState({ isActivitiesOpen: false })
          history.replace('www.demo.com')
        }}
        currentChild={currentPatient}
        havePhoneNumber={havePhoneNumber}
        isUserForwardFromHeader={true}
        history={history}
      />
    )
  }

  setEvaluationWarningModalOpen(evaluationWarningModalOpen: boolean): void {
    this.setState({ evaluationWarningModalOpen })
  }

  renderEvaluationWarningModal() {
    const { evaluationWarningModalOpen } = this.state
    const { PatientsLib, patientDetail } = this.props

    return (
      <EvaluationWarningModal
        active={evaluationWarningModalOpen}
        setActive={s => this.setEvaluationWarningModalOpen(s)}
        onButtonClick={() => {
          if (patientDetail) {
            const {
              patientId,
              assessments: { relevant_assessment }
            } = patientDetail

            PatientsLib.setCurrentAssessment(
              patientId,
              relevant_assessment,
              () => {
                PatientsLib.updateCurrentPatient()
                this.setEvaluationWarningModalOpen(false)
              },
              (error: string) => console.error(error)
            )
          } else {
            console.error('patientDetail is', { patientDetail })
          }
        }}
      />
    )
  }

  render() {
    const { patientDetail } = this.props
    const { loading } = this.state

    return (
      <div className="patient-detail">
        <div className="mobile-container">
          {!loading && patientDetail && (
            <div className="top-section">
              {this.renderTabs()}
              {this.renderTempEvalStatusModal()}
              {this.renderProggressionEvaluationModal()}
              {this.renderGameInstallationModal()}
              {this.renderActivitiesModal()}
              {this.renderEvaluationWarningModal()}
            </div>
          )}
        </div>
        {this.renderNewScoreModal()}
      </div>
    )
  }
}

const WithRouter = withRouter(PatientDetail)

const mapStateToProps = state => {
  return {
    patientDetail: state.patients.currentPatient,
    forms: state.forms.allForms,
    user: state.user.data,
    plusUser: state.plus_user.isPlusUser
  }
}

const mapDispatchToProps = (dispatch): IReduxDispatchProps => {
  return {
    PatientsLib: bindActionCreators(PatientActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter)



// WEBPACK FOOTER //
// ./src/components/HeaderDetail/index.tsx